import { render, staticRenderFns } from "./DocumentRow.vue?vue&type=template&id=1e248403&scoped=true"
import script from "./DocumentRow.vue?vue&type=script&lang=js"
export * from "./DocumentRow.vue?vue&type=script&lang=js"
import style0 from "./DocumentRow.vue?vue&type=style&index=0&id=1e248403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e248403",
  null
  
)

export default component.exports